<app-container-transparent>

    <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Sync Pipe">
            <app-sync-db></app-sync-db>
        </mat-tab>
        <mat-tab label="Cadastro Consultor">
            <app-consultor></app-consultor>
        </mat-tab>
    </mat-tab-group>

</app-container-transparent>
